import React from "react";
import { useTranslation } from "react-i18next";

export default function Header() {
  const [t, i18n] = useTranslation("global");
  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };
  return (
    <>
      {/* <h1>{t("header.message")}</h1>
      <button onClick={() => handleChangeLanguage("fa")}>Fa</button>
      <button onClick={() => handleChangeLanguage("en")}>En</button> */}
    </>
  );
}
